import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { get as _get, map as _map } from "lodash";
import { useDispatch } from "react-redux";

import { showAlertMessage } from "../../formElements";

import { updateLoadingState } from "../../../../redux/actions/application";
import { deleteSearchData } from "../../../../redux/services/dataSearch";

const DeleteSearchButton = ({
  source = "",
  selectedAllIds = false,
  selectedIds = [],
  selectedJobSeniority = [],
  selectedIndustry = [],
  selectedRegionCountry = [],
  selectedCompanySize = [],
  selectedRevenue = [],
  selectedDepartment = [],
  uploadedTalContactIds = [],
  savedSearchId = null,
  setState = () => { }
}) => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const handleDelete = async () => {
    try {
      if (typeof updateLoadingState === "function") { dispatch(updateLoadingState(true)); }

      const hasAnyFilter = [
        selectedIds,
        savedSearchId,
        selectedJobSeniority,
        selectedIndustry,
        selectedRegionCountry,
        selectedCompanySize,
        selectedRevenue,
        selectedDepartment,
        uploadedTalContactIds,
      ].some((arr) => (arr || []).length > 0);

      if (!hasAnyFilter) {
        showAlertMessage(
          intl.formatMessage({ id: "error.select_atleast_one_filter", defaultMessage: "Please select at least one filter." })
        );
        return;
      }

      const payload = {
        source: (source || ""),
        job_seniority: _map(selectedJobSeniority || [], (item) => _get(item, "id", "")),
        country: _map(selectedRegionCountry || [], (item) => _get(item, "id", "")),
        company_size: _map(selectedCompanySize || [], (item) => _get(item, "id", "")),
        revenue: _map(selectedRevenue || [], (item) => _get(item, "id", "")),
        department: _map(selectedDepartment || [], (item) => _get(item, "id", "")),
        selected_contact_ids: (selectedAllIds) ? [] : (selectedIds || []),
        tal_contact_ids: (uploadedTalContactIds || []),
        industry: _map(selectedIndustry || [], (item) => _get(item, "id", "")),
        search_id: (savedSearchId || null)
      };

      const response = await deleteSearchData(payload);

      if (_get(response, "flag", false) === true) {
        showAlertMessage(_get(response, "message", "Contact deleted successfully."), "success");

        // Refresh table and char
        if (typeof setState === "function") { setState({ refreshChartAndTable: true, selectedIds: [] }); }
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while deleting search data."));
      }
    } catch (err) {
      showAlertMessage(err.message || "Something went wrong while deleting search data.");
    } finally {
      if (typeof updateLoadingState === "function") { dispatch(updateLoadingState(false)); }
    }
  };

  return (
    <button type="button" className="btn btn-light waves-effect flex-fill text-capitalize" onClick={handleDelete}>
      <FormattedMessage id="btn.delete" defaultMessage="exportdelete" />
    </button>
  );
};

export default DeleteSearchButton;


